import React from 'react'
import './wholesaler.css'
import WholesalerApp from './Wholesaler.jsx'
import PropTypes from 'prop-types'

export const Wholesaler = ({ component }) => {
  let parameters = component.getParameters()
  let backgroundColor = parameters.backgroundColor
  return (
    <div className="Wholesaler">
      <WholesalerApp backgroundColor={backgroundColor}></WholesalerApp>
    </div>
  )
}
Wholesaler.propTypes = {
  component: PropTypes.shape({
    getParameters: PropTypes.func,
  }),
}
